import { render } from "./outbc2.vue?vue&type=template&id=d5a9e720&scoped=true"
import script from "./outbc2.vue?vue&type=script&lang=js"
export * from "./outbc2.vue?vue&type=script&lang=js"

import "./outbc2.vue?vue&type=style&index=0&id=d5a9e720&lang=less&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a9e720"]])

export default __exports__